
export const API_ENDPOINTS = {


  AUTH: {
    LOGIN: '/auth/login',
    USERS_SIMPLE_CREATE: '/auth/users/simple-create',
    USERS_SIMPLE_UPDATE: '/auth/users/simple-update',
    FORGOT_PASSWORD_SEND_OTP: '/auth/forgot-password',
    SIGNUP: '/auth/signup',
    VERIFY_OTP: '/auth/verify-otp',
    RESET_PASSWORD: '/auth/reset-password',
    RESEND_OTP: '/auth/resend-otp',
    PROFILE_UPDATE: '/auth/user/profile/update',
    PROFILE_GET: '/auth/me',
    SEND_OTP_TO_PHONE: '/auth/send-otp-to-phone',
    VERIFY_MOBILE_OTP: '/auth/verify-mobile-otp',
  },

  COMMON: {
    PHONE_CODE: '/master/phone-codes',
    EVENT_LIST: '/master/events',
    SERVICE_TYPES: '/master/service-types',
    CARGO_TYPES: '/master/cargo-types',
    CARRIERS: '/master/carriers',
    DOWNLOAD_BUNDLE: '/master/events/{{event_id}}/download-file',
    ORGANISERS_LIST: '/organisers/organiser-list',
    ORGANISERS_ALL: '/organisers/organiser-list-all',
    EVENTS_ALL: '/event/get-event-list-all',
    EXHIBITORS_ALL: '/exhibitors/all-exhibitors',
    EXHIBITORS_LIST: '/exhibitors/get-exhibitor-list',
    STAND_TYPES: '/master/get-all-stand-type?service_type={{service_type}}&venue={{venue}}&region={{region}}&is_old=false',
    DIMENSIONS_LIST: '/master/dimensions',
    WEIGHT_LIST: '/master/weights',
    GET_S3_UPLOAD_URL: '/master/get-s3-file-upload-url?fiepath={{filepath}}',
  },

  ORGANISERS: {
    VALIDATE_ORG_PASSCODE: '/organisers/validate-passcode',
    CREATE_ORGANISER: '/organisers/add-organiser',
    UPDATE_ORGANISER: '/organisers/update-organiser/{{organiser_id}}',
  },

  EVENTS: {
    GET_EVENT_LIST: '/event/get-list',
    CREATE_EVENT: '/event/add-event',
    UPDATE_EVENT: '/event/update-event/{{event_id}}',
  },

  WAREHOUSES: {
    GET_WAREHOUSE_LIST: '/warehouse/get-list',
    UPDATE_WAREHOUSE: '/warehouse/update/{{warehouse_id}}',
    CREATE_WAREHOUSE: '/warehouse/submit',
  },

  ENQUIRY: {
    ENQUIRIES_LIST: '/forms/get-enquiry-list',
    ENQUIRIES_LIST_SIMPLE: '/forms/get-enquiry-list-simple',
    GET_ENQUIRY_BY_ID: '/forms/get-enquiry-by-id/{{enquiry_id}}',
    CREATE_ENQUIRY: '/forms/create-enquiries',
    UPDATE_ENQUIRY: '/forms/udpate-enquiry/{{enquiry_id}}',
    DELETE_ENQUIRY: '/forms/delete-enquiry/{{enquiry_id}}',
    SUBMIT_DRAFT: '/forms/enquiries/submit',
    GET_ENQUIRY_META: '/forms/get-meta-enquiry/{{enquiry_id}}',
    UPDATE_ENQUIRY_META: '/forms/update-enquiry-meta/{{enquiry_id}}',
  },

  PAYMENT: {
    PAYMENT_INITIATE: '/payment/create-checkout-session',
    CHECK_STATUS: '/payment/check-status',
    GET_PAYMENT_LIST: '/payment/history-list',
    GET_PAYMENT_DETAILS: '/payment/get-payment-by-id/{{payment_id}}',
  },

  TRACKING: {
    GET_TRACKING_LIST: '/tracking/shipping-list',
    GET_RETURN_TRACKING_LIST: '/tracking/return-list',
  },

  ADMIN: {
    GET_FEEDBACKS: '/feedback/get-list',
    CREATE_LABEL: '/master/get-label-pdf',
    GENERATE_MANIFEST: '/master/generate-excel-wdrive?month={{month}}&year={{year}}&update_drive={{update_drive}}&is_download={{is_download}}',
    DASHBOARD: '/admin/dashboard',
    DASHBOARD_LAYOUT: '/dashboard/layout',
    FM_LAYOUT: '/admin/fm/layout',
    EVENT_SHOW_DASHBOARD: '/admin/event-show-dashboard',
  },

  FUNCTIONS: {
    PROCESS_FORM_WITH_AUTO_FORM_CREATION: '/functions/processFormWithAutoFormCreation',
  },
  
  TEAMS: {
    ADD_TEAM: '/teams/add-team',
    UPDATE_TEAM: '/teams/{{team_id}}',
    TEAM_LIST: '/teams/team-list',
    DELETE_TEAM: '/teams/delete/{{team_id}}',
  },
  EXCEL: {
    GENERATE_EXCEL: '/forms/generate-excel-from-enquiry/{{enquiry_id}}/{{update_method}}',
  },

  MASTER: {
    GET_ENQ_JSON: '/master/get-enq-json',
    CREATE_ENQ_JSON: '/master/create-enq-json',
  },

  MEMBERS: {
    ADD_MEMBER: '/members/add-member',
    UPDATE_MEMBER: '/members/{{member_id}}',
    MEMBER_LIST: '/members/member-list',
    DELETE_MEMBER: '/members/delete/{{member_id}}',
  },

} as const;



